// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__rgm3R","sectionsWrapper":"style_sectionsWrapper__15PxZ","tableWrapper":"style_tableWrapper__2wixT","tableTitle":"style_tableTitle__1-6Go"};